import { useReducer } from 'react';

export interface Action {
  type: 'loaded' | 'failed';
}

export const useSocialReducer = (initState: {
  loaded: boolean;
  failed: boolean;
}) => {
  const reducer = (_: unknown, action: Action) => {
    switch (action.type) {
      case 'loaded':
        return { loaded: true, failed: false };
      case 'failed':
        return { loaded: false, failed: true };
    }
  };

  const [scrState, dispatch] = useReducer(reducer, initState);

  return { scrState, dispatch };
};
